"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _button = _interopRequireDefault(require("britive-design-system/core/components/button"));

var _dialog = _interopRequireDefault(require("britive-design-system/core/components/dialog"));

var _snackbar = _interopRequireDefault(require("britive-design-system/core/components/snackbar"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _useValidationHook = _interopRequireDefault(require("../../use-validation-hook"));

var _commonConstants = require("../../../utils/common-constants");

var _commonUtils = require("../../../utils/common-utils");

var _utils = require("../utils");

var _AddPolicyForm = _interopRequireDefault(require("./add-policy-form/AddPolicyForm"));

var _policyJsonEditor = _interopRequireDefault(require("../../policy-admin/add-policy/policy-json-editor"));

var _constants = require("./constants");

var _validation = require("./validation.rules");

var _lodash = require("lodash");

var _reactRedux = require("react-redux");

var _actions = require("./actions");

var _utils2 = require("../../advanced-settings/utils");

var _utils3 = require("../../policy-admin/add-policy/steps/associations/utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.add-policy-button-container {\n  width: 100%;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-between;\n  font-family: 'OpenSansRegular';\n  background-color: #f4f4f4;\n  padding-bottom: 1rem;\n  padding-left: 3.5rem;\n  padding-right: 3.5rem;\n  position: sticky;\n  width: 100%; }\n  .add-policy-button-container .add-policy-buttons-container-left {\n    display: flex; }\n    .add-policy-button-container .add-policy-buttons-container-left .add-policy-button-container-left {\n      margin-right: 1rem; }\n\n.add-policy-snackbar {\n  margin-left: 3.5rem;\n  margin-right: 3.5rem; }\n";
  var fileName = "compone_AddPolicy";
  var element = document.querySelector("style[data-sass-component='compone_AddPolicy']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var AddPolicy = function AddPolicy(_ref) {
  var _applicationRoot$cata, _editPolicy$loadedPol10, _editPolicy$loadedPol11, _editPolicy$loadedPol12;

  var openNotification = _ref.openNotification,
      createPolicy = _ref.createPolicy,
      setPageHeader = _ref.setPageHeader,
      addPolicy = _ref.addPolicy,
      fetchUsers = _ref.fetchUsers,
      usersData = _ref.usersData,
      usersDataStatus = _ref.usersDataStatus,
      fetchGroups = _ref.fetchGroups,
      groupsData = _ref.groupsData,
      groupsDataStatus = _ref.groupsDataStatus,
      fetchServiceIdentities = _ref.fetchServiceIdentities,
      serviceIdentitiesData = _ref.serviceIdentitiesData,
      serviceIdentitiesDataStatus = _ref.serviceIdentitiesDataStatus,
      fetchTokens = _ref.fetchTokens,
      tokensData = _ref.tokensData,
      tokensDataStatus = _ref.tokensDataStatus,
      fetchPermissionsList = _ref.fetchPermissionsList,
      permissionsList = _ref.permissionsList,
      fetchConsumersList = _ref.fetchConsumersList,
      consumersList = _ref.consumersList,
      fetchPermissionDetails = _ref.fetchPermissionDetails,
      permissionDetails = _ref.permissionDetails,
      fetchPermissionActions = _ref.fetchPermissionActions,
      permissionActionsList = _ref.permissionActionsList,
      permissionActionsListStatus = _ref.permissionActionsListStatus,
      permissionDetailsStatus = _ref.permissionDetailsStatus,
      fetchRolesList = _ref.fetchRolesList,
      rolesListStatus = _ref.rolesListStatus,
      fetchRoleDetails = _ref.fetchRoleDetails,
      rolesList = _ref.rolesList,
      roleDetails = _ref.roleDetails,
      roleDetailsStatus = _ref.roleDetailsStatus,
      history = _ref.history,
      consumerEntityId = _ref.consumerEntityId,
      addPolicyErrors = _ref.addPolicyErrors,
      addPolicyStatus = _ref.addPolicyStatus,
      editPolicy = _ref.editPolicy,
      clonePolicy = _ref.clonePolicy,
      resetActionsData = _ref.resetActionsData,
      initSpinnerOverlay = _ref.initSpinnerOverlay,
      permissionsListStatus = _ref.permissionsListStatus,
      getApplicationsList = _ref.getApplicationsList,
      applicationsListData = _ref.applicationsListData,
      applicationsListStatus = _ref.applicationsListStatus,
      redirectPath = _ref.redirectPath,
      validateChannelListStatus = _ref.validateChannelListStatus,
      validateChannelListError = _ref.validateChannelListError,
      _ref$isConditionTypeJ = _ref.isConditionTypeJSON,
      isConditionTypeJSON = _ref$isConditionTypeJ === void 0 ? true : _ref$isConditionTypeJ;
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    var _state$policyReducer, _state$policyReducer$;

    return state === null || state === void 0 ? void 0 : (_state$policyReducer = state.policyReducer) === null || _state$policyReducer === void 0 ? void 0 : (_state$policyReducer$ = _state$policyReducer.add) === null || _state$policyReducer$ === void 0 ? void 0 : _state$policyReducer$.profileSettings;
  }),
      profileSettingsData = _useSelector.data;

  var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
    var _state$policyReducer2, _state$policyReducer3;

    return state === null || state === void 0 ? void 0 : (_state$policyReducer2 = state.policyReducer) === null || _state$policyReducer2 === void 0 ? void 0 : (_state$policyReducer3 = _state$policyReducer2.associationsReducer) === null || _state$policyReducer3 === void 0 ? void 0 : _state$policyReducer3.applicationRoot;
  }),
      applicationLoading = _useSelector2.loading,
      applicationRoot = _useSelector2.data;

  var _useSelector3 = (0, _reactRedux.useSelector)(function (state) {
    var _state$policyReducer4, _state$policyReducer5;

    return state === null || state === void 0 ? void 0 : (_state$policyReducer4 = state.policyReducer) === null || _state$policyReducer4 === void 0 ? void 0 : (_state$policyReducer5 = _state$policyReducer4.associationsReducer) === null || _state$policyReducer5 === void 0 ? void 0 : _state$policyReducer5.scopesRoot;
  }),
      scopesLoading = _useSelector3.loading,
      scopesRootData = _useSelector3.data;

  var _useSelector4 = (0, _reactRedux.useSelector)(function (state) {
    var _state$policyReducer6, _state$policyReducer7;

    return state === null || state === void 0 ? void 0 : (_state$policyReducer6 = state.policyReducer) === null || _state$policyReducer6 === void 0 ? void 0 : (_state$policyReducer7 = _state$policyReducer6.associationsReducer) === null || _state$policyReducer7 === void 0 ? void 0 : _state$policyReducer7.environmentsRoot;
  }),
      environmentsLoading = _useSelector4.loading;

  var requiresHierarchicalModel = applicationRoot === null || applicationRoot === void 0 ? void 0 : (_applicationRoot$cata = applicationRoot.catalogApplication) === null || _applicationRoot$cata === void 0 ? void 0 : _applicationRoot$cata.requiresHierarchicalModel;
  var isEditMode = Boolean(editPolicy);
  var isCloneMode = Boolean(clonePolicy);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isJSON = _useState2[0],
      setIsJSON = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showNoMembersDialog = _useState4[0],
      setShowNoMembersDialog = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      policyFilterLoading = _useState6[0],
      setPolicyFilterLoading = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      validationErrors = _useState8[0],
      setValidationErrors = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      cancelModal = _useState10[0],
      setCancelModal = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      switchForm = _useState12[0],
      setSwitchForm = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = _slicedToArray(_useState13, 2),
      submit = _useState14[0],
      setSubmit = _useState14[1];

  var buttonText = _constants.translatedStrings.switchMode(isJSON);

  var _useState15 = (0, _react.useState)(false),
      _useState16 = _slicedToArray(_useState15, 2),
      channelValidation = _useState16[0],
      setChannelValidation = _useState16[1];

  var _useState17 = (0, _react.useState)([{
    settingsType: "",
    id: "",
    entityId: "",
    entityType: "",
    isInherited: false,
    isJustificationRequired: false,
    justificationRegex: ""
  }, {
    settingsType: "",
    id: "",
    entityId: "",
    entityType: "",
    isInherited: false,
    connectionId: "",
    connectionType: "",
    isCommentRequired: false,
    isITSMEnabled: false,
    itsmFilterCriteria: []
  }]),
      _useState18 = _slicedToArray(_useState17, 2),
      settings = _useState18[0],
      setSettings = _useState18[1]; // Assuming settingsData?.settings is an array of objects


  var updateSettings = function updateSettings(settings) {
    var newSettings = [{
      // Default JUSTIFICATION settings
      settingsType: "",
      id: "",
      entityId: "",
      entityType: "",
      isInherited: false,
      isJustificationRequired: false,
      justificationRegex: ""
    }, {
      // Default ITSM settings
      settingsType: "",
      id: "",
      entityId: "",
      entityType: "",
      isInherited: false,
      connectionId: "",
      connectionType: "",
      isCommentRequired: false,
      isITSMEnabled: false,
      itsmFilterCriteria: []
    }]; // If settings is provided, update the relevant indexes

    if (settings && Array.isArray(settings)) {
      settings === null || settings === void 0 ? void 0 : settings.forEach(function (setting) {
        if ((setting === null || setting === void 0 ? void 0 : setting.settingsType) === 'ITSM') {
          newSettings[1] = _objectSpread(_objectSpread({}, newSettings[1]), setting); // Update ITSM settings
        } else if ((setting === null || setting === void 0 ? void 0 : setting.settingsType) === 'JUSTIFICATION') {
          newSettings[0] = _objectSpread(_objectSpread({}, newSettings[0]), setting); // Update JUSTIFICATION settings
        }
      });
    } // Update the state with the modified settings


    setSettings(newSettings);
  };

  (0, _react.useEffect)(function () {
    if ((0, _utils2.isAddPolicyPath)()) {
      updateSettings(profileSettingsData === null || profileSettingsData === void 0 ? void 0 : profileSettingsData.settings);
    }
  }, [profileSettingsData === null || profileSettingsData === void 0 ? void 0 : profileSettingsData.settings]); // Handle change for JUSTIFICATION settings

  var handleJustificationChange = function handleJustificationChange(updatedSetting) {
    setSettings(function (prevState) {
      return [_objectSpread(_objectSpread(_objectSpread({}, prevState[0]), updatedSetting), {}, {
        entityType: 'POLICY'
      }), // Update JUSTIFICATION settings
      prevState[1] // Keep ITSM settings unchanged
      ];
    });
  }; // Handle change for ITSM settings


  var handleITSMChange = function handleITSMChange(updatedSetting) {
    setSettings(function (prevState) {
      return [prevState[0], // Keep JUSTIFICATION settings unchanged
      _objectSpread(_objectSpread(_objectSpread({}, prevState[1]), updatedSetting), {}, {
        entityType: 'POLICY'
      }) // Update ITSM settings
      ];
    });
  }; // Justification Handle Reset change for ITSM settings


  var handleResetJustification = function handleResetJustification() {
    var _profileSettingsData$;

    var justificationSettings = profileSettingsData === null || profileSettingsData === void 0 ? void 0 : (_profileSettingsData$ = profileSettingsData.settings) === null || _profileSettingsData$ === void 0 ? void 0 : _profileSettingsData$.find(function (setting) {
      return (setting === null || setting === void 0 ? void 0 : setting.settingsType) === 'JUSTIFICATION';
    });
    setSettings(function (prevState) {
      return [justificationSettings !== null && justificationSettings !== void 0 ? justificationSettings : {
        entityId: '',
        entityType: '',
        id: '',
        isJustificationRequired: false,
        settingsType: ''
      }, prevState[1] // Keep ITSM settings unchanged
      ];
    });
  };

  var showToast = function showToast(title) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'success';
    openNotification(type, title, 3000);
  }; // Handle change for Reset ITSM settings


  var handleResetITSM = function handleResetITSM() {
    var _profileSettingsData$2;

    // const ITSMResponse = settings?.find((key) => key?.settingsType === 'ITSM');
    var ITSMSettings = profileSettingsData === null || profileSettingsData === void 0 ? void 0 : (_profileSettingsData$2 = profileSettingsData.settings) === null || _profileSettingsData$2 === void 0 ? void 0 : _profileSettingsData$2.find(function (setting) {
      return (setting === null || setting === void 0 ? void 0 : setting.settingsType) === 'ITSM';
    });
    setSettings(function (prevState) {
      return [prevState[0], // Keep JUSTIFICATION settings unchanged
      ITSMSettings !== null && ITSMSettings !== void 0 ? ITSMSettings : {
        settingsType: '',
        entityType: '',
        connectionId: '',
        connectionType: '',
        isITSMEnabled: false,
        itsmFilterCriteria: []
      }];
    });
  };

  (0, _react.useEffect)(function () {
    if (consumerEntityId && !(0, _utils.isAccessBuilderPath)()) {
      dispatch((0, _actions.fetchProfileSettingsRequest)(consumerEntityId));
    }
  }, [consumerEntityId]);
  (0, _react.useEffect)(function () {
    if (isEditMode) {
      if ((editPolicy === null || editPolicy === void 0 ? void 0 : editPolicy.editPolicyStatus) === _commonConstants.RESOURCE_STATUS.SUCCESS) {
        setValidationErrors(null);
      } else if ((editPolicy === null || editPolicy === void 0 ? void 0 : editPolicy.editPolicyStatus) === _commonConstants.RESOURCE_STATUS.ERROR) {
        var _editPolicy$editPolic;

        setValidationErrors(editPolicy === null || editPolicy === void 0 ? void 0 : (_editPolicy$editPolic = editPolicy.editPolicyErrors) === null || _editPolicy$editPolic === void 0 ? void 0 : _editPolicy$editPolic.split('|'));
      }
    } else {
      if (addPolicyStatus === _commonConstants.RESOURCE_STATUS.SUCCESS) {
        setValidationErrors(null);
      } else if (addPolicyStatus === _commonConstants.RESOURCE_STATUS.ERROR) {
        setValidationErrors(addPolicyErrors === null || addPolicyErrors === void 0 ? void 0 : addPolicyErrors.split('|'));
      }
    }
  }, [addPolicyErrors, editPolicy === null || editPolicy === void 0 ? void 0 : editPolicy.editPolicyErrors]);
  (0, _react.useEffect)(function () {
    return setValidationErrors(null);
  }, [isJSON]);
  (0, _react.useEffect)(function () {
    if (editPolicy !== null && editPolicy !== void 0 && editPolicy.loadedPolicy) {
      var _editPolicy$loadedPol, _editPolicy$loadedPol4;

      setValidationErrors(null);

      if (editPolicy !== null && editPolicy !== void 0 && (_editPolicy$loadedPol = editPolicy.loadedPolicy) !== null && _editPolicy$loadedPol !== void 0 && _editPolicy$loadedPol.isValidForInDays) {
        var _editPolicy$loadedPol2;

        validationHook.resetValues(_objectSpread(_objectSpread({}, editPolicy === null || editPolicy === void 0 ? void 0 : editPolicy.loadedPolicy), {}, {
          validForDays: editPolicy === null || editPolicy === void 0 ? void 0 : (_editPolicy$loadedPol2 = editPolicy.loadedPolicy) === null || _editPolicy$loadedPol2 === void 0 ? void 0 : _editPolicy$loadedPol2.validFor,
          validFor: ''
        }));
      } else {
        var _editPolicy$loadedPol3;

        validationHook.resetValues(_objectSpread(_objectSpread({}, editPolicy === null || editPolicy === void 0 ? void 0 : editPolicy.loadedPolicy), {}, {
          validFor: editPolicy === null || editPolicy === void 0 ? void 0 : (_editPolicy$loadedPol3 = editPolicy.loadedPolicy) === null || _editPolicy$loadedPol3 === void 0 ? void 0 : _editPolicy$loadedPol3.validFor
        }));
      }

      jsonValidationHook.resetValues(editPolicy === null || editPolicy === void 0 ? void 0 : editPolicy.loadedPolicyJSON);

      if (!(0, _lodash.isEmpty)(editPolicy === null || editPolicy === void 0 ? void 0 : (_editPolicy$loadedPol4 = editPolicy.loadedPolicy) === null || _editPolicy$loadedPol4 === void 0 ? void 0 : _editPolicy$loadedPol4.settings)) {
        var _editPolicy$loadedPol5;

        updateSettings(editPolicy === null || editPolicy === void 0 ? void 0 : (_editPolicy$loadedPol5 = editPolicy.loadedPolicy) === null || _editPolicy$loadedPol5 === void 0 ? void 0 : _editPolicy$loadedPol5.settings);
      }
    }
  }, [editPolicy === null || editPolicy === void 0 ? void 0 : editPolicy.loadedPolicy]);
  (0, _react.useEffect)(function () {
    if (clonePolicy !== null && clonePolicy !== void 0 && clonePolicy.loadedPolicy) {
      var _clonePolicy$loadedPo, _clonePolicy$loadedPo4;

      if (clonePolicy !== null && clonePolicy !== void 0 && (_clonePolicy$loadedPo = clonePolicy.loadedPolicy) !== null && _clonePolicy$loadedPo !== void 0 && _clonePolicy$loadedPo.isValidForInDays) {
        var _clonePolicy$loadedPo2;

        validationHook.resetValues(_objectSpread(_objectSpread({}, clonePolicy === null || clonePolicy === void 0 ? void 0 : clonePolicy.loadedPolicy), {}, {
          validForDays: clonePolicy === null || clonePolicy === void 0 ? void 0 : (_clonePolicy$loadedPo2 = clonePolicy.loadedPolicy) === null || _clonePolicy$loadedPo2 === void 0 ? void 0 : _clonePolicy$loadedPo2.validFor,
          validFor: ''
        }));
      } else {
        var _clonePolicy$loadedPo3;

        validationHook.resetValues(_objectSpread(_objectSpread({}, clonePolicy === null || clonePolicy === void 0 ? void 0 : clonePolicy.loadedPolicy), {}, {
          validFor: clonePolicy === null || clonePolicy === void 0 ? void 0 : (_clonePolicy$loadedPo3 = clonePolicy.loadedPolicy) === null || _clonePolicy$loadedPo3 === void 0 ? void 0 : _clonePolicy$loadedPo3.validFor
        }));
      }

      if (!(0, _lodash.isEmpty)(clonePolicy === null || clonePolicy === void 0 ? void 0 : (_clonePolicy$loadedPo4 = clonePolicy.loadedPolicy) === null || _clonePolicy$loadedPo4 === void 0 ? void 0 : _clonePolicy$loadedPo4.settings)) {
        var _clonePolicy$loadedPo5;

        updateSettings(clonePolicy === null || clonePolicy === void 0 ? void 0 : (_clonePolicy$loadedPo5 = clonePolicy.loadedPolicy) === null || _clonePolicy$loadedPo5 === void 0 ? void 0 : _clonePolicy$loadedPo5.settings);
      }
    }
  }, [clonePolicy === null || clonePolicy === void 0 ? void 0 : clonePolicy.loadedPolicy]);
  (0, _react.useEffect)(function () {
    if (clonePolicy !== null && clonePolicy !== void 0 && clonePolicy.loadedPolicyJSON) jsonValidationHook.resetValues({
      JSONInputData: clonePolicy === null || clonePolicy === void 0 ? void 0 : clonePolicy.loadedPolicyJSON
    });
  }, [clonePolicy === null || clonePolicy === void 0 ? void 0 : clonePolicy.loadedPolicyJSON]);

  var submitPolicyJSON = function submitPolicyJSON(policyJSONPayload) {
    var _editPolicy$loadedPol6;

    var policyJSON = _objectSpread({}, policyJSONPayload);

    if (!(0, _lodash.isEmpty)(policyJSON === null || policyJSON === void 0 ? void 0 : policyJSON.condition)) {
      policyJSON['condition'] = isConditionTypeJSON ? policyJSON.condition : JSON.stringify(policyJSON.condition);
    } else {
      policyJSON['condition'] = isConditionTypeJSON ? {} : '';
    }

    policyJSON === null || policyJSON === void 0 ? true : delete policyJSON.isConditionTypeJSON;
    setValidationErrors(null);
    isEditMode ? editPolicy === null || editPolicy === void 0 ? void 0 : editPolicy.updatePolicy(_objectSpread({}, policyJSON), history, editPolicy === null || editPolicy === void 0 ? void 0 : (_editPolicy$loadedPol6 = editPolicy.loadedPolicy) === null || _editPolicy$loadedPol6 === void 0 ? void 0 : _editPolicy$loadedPol6.name, _commonConstants.papServiceConsumer, consumerEntityId, redirectPath) : createPolicy(_objectSpread({}, policyJSON), history, _commonConstants.papServiceConsumer, consumerEntityId, redirectPath);
  };

  var jsonValidationHook = (0, _useValidationHook.default)({
    initialValues: {
      JSONInputData: ''
    },
    validationSchema: (0, _validation.getJSONValidationSchema)(),
    onSubmit: function onSubmit(_ref2) {
      var JSONInputData = _ref2.JSONInputData;
      return submitPolicyJSON(_objectSpread({}, JSON.parse(JSONInputData)));
    }
  });

  var submitPolicy = function submitPolicy(values, isDraft) {
    var _editPolicy$loadedPol9;

    var justificationParent = (0, _utils.findSettingByType)(profileSettingsData === null || profileSettingsData === void 0 ? void 0 : profileSettingsData.settings, 'JUSTIFICATION');
    var justificationChild = (0, _utils.findSettingByType)(settings, 'JUSTIFICATION');
    var ITSMParent = (0, _utils.findSettingByType)(profileSettingsData === null || profileSettingsData === void 0 ? void 0 : profileSettingsData.settings, 'ITSM');
    var ITSMChild = (0, _utils.findSettingByType)(settings, 'ITSM'); // Map through settings and replace with null if unchanged

    var newSettings = settings === null || settings === void 0 ? void 0 : settings.map(function (setting, index) {
      if (index === 0 && (0, _lodash.isEqual)(justificationParent, justificationChild)) return null;
      if (index === 1 && (0, _lodash.isEqual)(ITSMParent, ITSMChild)) return null;
      return setting;
    });
    setValidationErrors(null);
    var policy = (0, _utils.massagePolicyBeforeSave)(_objectSpread(_objectSpread({}, values), {}, {
      name: values.name.trim(),
      isDraft: isDraft
    }), {
      placeHolderCondition: _constants.translatedStrings.placeHolderCondition,
      inlineType: _constants.translatedStrings.inlineType
    }, isConditionTypeJSON, (0, _utils.sanitizedSettings)(newSettings), getProcessedScopes(values.scopes, applicationRoot), requiresHierarchicalModel);
    var updatedScopes = (0, _utils.compareAssociations)((policy === null || policy === void 0 ? void 0 : policy.scopes) || [], scopesRootData);

    var getUpdatedPolicyObj = function getUpdatedPolicyObj() {
      if (policy) {
        var _editPolicy$loadedPol7, _editPolicy$loadedPol8;

        if ((0, _utils.areMembersEmpty)(validationHook.values)) {
          policy['members'] = {
            users: [],
            tags: [],
            tokens: [],
            serviceIdentities: []
          };
        }

        var name = policy.name,
            description = policy.description,
            members = policy.members,
            condition = policy.condition,
            _isDraft = policy.isDraft,
            isActive = policy.isActive;
        var id = editPolicy === null || editPolicy === void 0 ? void 0 : (_editPolicy$loadedPol7 = editPolicy.loadedPolicy) === null || _editPolicy$loadedPol7 === void 0 ? void 0 : _editPolicy$loadedPol7.name;

        if (editPolicy !== null && editPolicy !== void 0 && (_editPolicy$loadedPol8 = editPolicy.loadedPolicy) !== null && _editPolicy$loadedPol8 !== void 0 && _editPolicy$loadedPol8.isReadOnly) {
          return _objectSpread(_objectSpread(_objectSpread({
            id: id,
            isActive: Boolean(!(0, _utils.areMembersEmpty)(validationHook.values) || isActive),
            isDraft: _isDraft,
            members: members
          }, (0, _utils.isResourcePolicyPath)() && {
            accessLevel: validationHook.values.accessLevel
          }), (0, _utils.isServerAccessPath)() && {
            resourceLabels: (0, _utils.removeEmptyLabelsValues)(validationHook.values.resourceLabels)
          }), {}, {
            settings: (0, _utils.sanitizedSettings)(newSettings),
            scopes: updatedScopes
          });
        } else {
          return _objectSpread(_objectSpread(_objectSpread({
            id: id,
            name: name,
            description: description,
            members: members,
            isActive: !(0, _utils.areMembersEmpty)(validationHook.values) || isActive,
            condition: condition,
            isDraft: _isDraft
          }, (0, _utils.isResourcePolicyPath)() && {
            accessLevel: validationHook.values.accessLevel
          }), (0, _utils.isServerAccessPath)() && {
            resourceLabels: (0, _utils.removeEmptyLabelsValues)(validationHook.values.resourceLabels)
          }), {}, {
            settings: (0, _utils.sanitizedSettings)(newSettings),
            scopes: updatedScopes
          });
        }
      }
    };

    var policyToCreate = _objectSpread(_objectSpread({}, policy), {}, {
      isDraft: isDraft
    }, (0, _commonUtils.isApplicationProfilePolicyPath)() && !requiresHierarchicalModel && {
      scopes: updatedScopes
    });

    isEditMode ? editPolicy === null || editPolicy === void 0 ? void 0 : editPolicy.updatePolicy(getUpdatedPolicyObj(), history, editPolicy === null || editPolicy === void 0 ? void 0 : (_editPolicy$loadedPol9 = editPolicy.loadedPolicy) === null || _editPolicy$loadedPol9 === void 0 ? void 0 : _editPolicy$loadedPol9.id, _commonConstants.papServiceConsumer, consumerEntityId, redirectPath) : createPolicy(policyToCreate, history, _commonConstants.papServiceConsumer, consumerEntityId, redirectPath);
  };

  var validationHook = (0, _useValidationHook.default)({
    initialValues: {
      name: '',
      description: '',
      allowDeny: 'Allow',
      allUser: false,
      allServiceIdentity: false,
      allToken: false,
      allGroup: false,
      user: [],
      group: [],
      serviceIdentity: [],
      token: [],
      permissions: [],
      roles: [],
      isReadOnly: false,
      isActive: true,
      isDraft: false,
      isIpAddress: false,
      ipAddress: '',
      isDateTime: false,
      dateSchedule: false,
      startDate: null,
      endDate: null,
      timezone: null,
      daysSchedule: false,
      selectedDays: [],
      startTime: null,
      endTime: null,
      isApprovals: false,
      notificationMedium: [],
      channelList: [],
      isChannelsRequired: false,
      tagList: [],
      userList: [],
      approvalMaxTime: '',
      validFor: '',
      validForDays: '',
      isValidForInDays: true,
      stepUpVerificationEnabled: false,
      stepUpVerificationAlwaysPrompt: true,
      accessLevel: 'view',
      resourceLabels: {},
      slackAppChannels: [],
      teamsAppChannels: [],
      scopes: [],
      required: false,
      condition: 'Any'
    },
    validationSchema: (0, _validation.getValidationSchema)(setPolicyFilterLoading, editPolicy, openNotification, consumerEntityId),
    onSubmit: function onSubmit(values) {
      return submitPolicy(values, false);
    }
  });
  (0, _react.useEffect)(function () {
    if (!(0, _commonUtils.isApplicationProfilePolicyPath)() || requiresHierarchicalModel) return;
    var loadedPolicy = isEditMode ? editPolicy === null || editPolicy === void 0 ? void 0 : editPolicy.loadedPolicy : isCloneMode ? clonePolicy === null || clonePolicy === void 0 ? void 0 : clonePolicy.loadedPolicy : {};
    var scopes = !(0, _lodash.isEmpty)(loadedPolicy === null || loadedPolicy === void 0 ? void 0 : loadedPolicy.scopes) ? loadedPolicy.scopes : scopesRootData;

    if (!(0, _lodash.isEmpty)(scopes)) {
      var checkedNodes = (scopes === null || scopes === void 0 ? void 0 : scopes.map(function (obj) {
        return obj.value;
      })) || [];
      validationHook.handleChange(validationHook.names.scopes, checkedNodes);
    }
  }, [scopesRootData, editPolicy === null || editPolicy === void 0 ? void 0 : editPolicy.loadedPolicy, clonePolicy === null || clonePolicy === void 0 ? void 0 : clonePolicy.loadedPolicy]);

  var getProcessedScopes = function getProcessedScopes(scopes, applicationRoot) {
    var _applicationRoot$allE, _applicationRoot$root, _applicationRoot$root2;

    return (0, _utils3.getEntityForTheSelectedItems)(scopes !== null && scopes !== void 0 ? scopes : [], (_applicationRoot$allE = applicationRoot === null || applicationRoot === void 0 ? void 0 : applicationRoot.allEnvironmentGroupMap) !== null && _applicationRoot$allE !== void 0 ? _applicationRoot$allE : {}, (0, _utils3.getEnvironmentsById)((_applicationRoot$root = applicationRoot === null || applicationRoot === void 0 ? void 0 : (_applicationRoot$root2 = applicationRoot.rootEnvironmentGroup) === null || _applicationRoot$root2 === void 0 ? void 0 : _applicationRoot$root2.environments) !== null && _applicationRoot$root !== void 0 ? _applicationRoot$root : [], 'id'));
  };

  (0, _react.useEffect)(function () {
    var getPageHeader = function getPageHeader() {
      if (isEditMode) return _constants.translatedStrings.editPageTitle;else return _constants.translatedStrings.pageTitle;
    };

    setPageHeader(getPageHeader(), []);
    getApplicationsList();
  }, []);

  var switchHandler = function switchHandler() {
    var orgIsJSON = isJSON;
    setSubmit(false);
    setSwitchForm(true);
    setIsJSON(!isJSON);

    if (isEditMode || isCloneMode) {
      if (!orgIsJSON) {
        var jsonPolicy = isEditMode ? editPolicy.loadedPolicyJSON : clonePolicy.loadedPolicyJSON;
        jsonValidationHook.resetValues(jsonPolicy);
      } else {
        var inputPolicy = isEditMode ? editPolicy === null || editPolicy === void 0 ? void 0 : editPolicy.loadedPolicy : clonePolicy === null || clonePolicy === void 0 ? void 0 : clonePolicy.loadedPolicy;
        validationHook.resetValues(inputPolicy);
      }
    } else {
      validationHook.resetForm();
      jsonValidationHook.resetForm();
    }

    setValidationErrors(null);
  };

  var allFieldsValidationErrors = function allFieldsValidationErrors() {
    var errors = [];

    for (var key in validationHook.errors) {
      if (validationHook.errors[key]) {
        key !== 'roles' && key !== 'user' && key !== 'group' && key !== 'serviceIdentity' && errors.push(validationHook.errors[key]);
      }
    }

    return errors.length ? errors : null;
  };

  (0, _react.useEffect)(function () {
    if (channelValidation) {
      if ((0, _utils.isSuccess)(validateChannelListStatus)) {
        validationHook.handleSubmit();
        setChannelValidation(false);
      } else if ((0, _commonUtils.isError)(validateChannelListStatus)) {
        var _allFieldsValidationE;

        ((_allFieldsValidationE = allFieldsValidationErrors()) === null || _allFieldsValidationE === void 0 ? void 0 : _allFieldsValidationE.length) && validationHook.handleSubmit();
      }
    }
  }, [channelValidation, validateChannelListStatus, validateChannelListError]);
  (0, _react.useEffect)(function () {
    if (submit && !isJSON) {
      if (!(0, _commonUtils.isLoading)(validateChannelListStatus)) {
        var validationErr = allFieldsValidationErrors();

        if (validationErr) {
          setValidationErrors(validationErr);
        } else {
          setValidationErrors(null);
        }
      }
    }
  }, [validationHook.errors, submit, validateChannelListStatus, validateChannelListError]);

  var postPolicyHandler = function postPolicyHandler() {
    setSubmit(true);

    if (!isJSON) {
      validationHook.handleSubmit();
    } else {
      jsonValidationHook.handleSubmit();
    }
  };

  var addPolicyFormProps = {
    addPolicyErrors: addPolicyErrors,
    openNotification: openNotification,
    validationHook: validationHook,
    addPolicy: addPolicy,
    fetchUsers: fetchUsers,
    usersData: usersData,
    usersDataStatus: usersDataStatus,
    fetchGroups: fetchGroups,
    groupsData: groupsData,
    groupsDataStatus: groupsDataStatus,
    fetchServiceIdentities: fetchServiceIdentities,
    serviceIdentitiesData: serviceIdentitiesData,
    serviceIdentitiesDataStatus: serviceIdentitiesDataStatus,
    fetchTokens: fetchTokens,
    tokensData: tokensData,
    tokensDataStatus: tokensDataStatus,
    fetchPermissionsList: fetchPermissionsList,
    permissionsList: permissionsList,
    fetchConsumersList: fetchConsumersList,
    consumersList: consumersList,
    fetchPermissionDetails: fetchPermissionDetails,
    permissionDetails: permissionDetails,
    fetchPermissionActions: fetchPermissionActions,
    permissionActionsList: permissionActionsList,
    permissionActionsListStatus: permissionActionsListStatus,
    permissionDetailsStatus: permissionDetailsStatus,
    fetchRolesList: fetchRolesList,
    rolesListStatus: rolesListStatus,
    fetchRoleDetails: fetchRoleDetails,
    rolesList: rolesList,
    roleDetails: roleDetails,
    roleDetailsStatus: roleDetailsStatus,
    policyFilterLoading: policyFilterLoading,
    validationErrors: validationErrors,
    editReadOnly: editPolicy === null || editPolicy === void 0 ? void 0 : editPolicy.editReadOnly,
    isEditMode: isEditMode,
    resetActionsData: resetActionsData,
    initSpinnerOverlay: initSpinnerOverlay,
    permissionsListStatus: permissionsListStatus,
    getApplicationsList: getApplicationsList,
    applicationsListData: applicationsListData,
    applicationsListStatus: applicationsListStatus,
    isCloneMode: isCloneMode,
    consumerEntityId: consumerEntityId,
    settings: settings,
    handleJustificationChange: handleJustificationChange,
    handleITSMChange: handleITSMChange,
    handleResetJustification: handleResetJustification,
    handleResetITSM: handleResetITSM,
    showToast: showToast,
    parentsSettings: (profileSettingsData === null || profileSettingsData === void 0 ? void 0 : profileSettingsData.settings) || {}
  };
  var addPolicyJSONProps = {
    validationHook: jsonValidationHook,
    openNotification: openNotification,
    editReadOnly: editPolicy === null || editPolicy === void 0 ? void 0 : editPolicy.editReadOnly,
    validationErrors: validationErrors,
    translatedStrings: _constants.translatedStrings,
    settings: settings,
    handleJustificationChange: handleJustificationChange,
    handleITSMChange: handleITSMChange
  };

  var cancelHandler = function cancelHandler() {
    history.push(redirectPath);
    validationHook.resetForm();
    setValidationErrors(null);
  };

  var saveDraftHandler = function saveDraftHandler() {
    if (!isJSON) {
      validationHook.handleBlur(validationHook.names.name);
      submitPolicy(validationHook.values, true);
    } else {
      if (jsonValidationHook.errors.JSONInputData) {
        setValidationErrors([jsonValidationHook.errors.JSONInputData]);
      } else {
        setValidationErrors(null);
      }

      var policyJSON = JSON.parse(jsonValidationHook.values.JSONInputData);
      jsonValidationHook.resetValues({
        JSONInputData: JSON.stringify(_objectSpread({}, policyJSON), null, 4)
      });
      submitPolicyJSON(_objectSpread({}, policyJSON), true);
    }
  };

  (0, _react.useEffect)(function () {
    initSpinnerOverlay({
      open: environmentsLoading || scopesLoading || applicationLoading,
      size: 'medium',
      message: 'Loading...'
    });
  }, [environmentsLoading, scopesLoading, applicationLoading]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyButtonContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyButtonsContainerLeft
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyButtonContainerLeft
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    size: "medium",
    variant: "primary",
    onClick: (0, _lodash.debounce)(function () {
      validationHook.handleChange(validationHook.names.isDraft, false);

      if (!isJSON && (0, _utils.areMembersEmpty)(validationHook.values)) {
        (0, _commonUtils.resetMembers)(validationHook);
        setShowNoMembersDialog(true);
      } else {
        postPolicyHandler();
      }
    }, 300)
  }, isEditMode && editPolicy !== null && editPolicy !== void 0 && (_editPolicy$loadedPol10 = editPolicy.loadedPolicy) !== null && _editPolicy$loadedPol10 !== void 0 && _editPolicy$loadedPol10.isActive || isJSON || (0, _utils.isAccessBuilderPath)() ? _constants.translatedStrings.saveBtn : _constants.translatedStrings.saveAndEnable)), !(isJSON || isEditMode && (editPolicy !== null && editPolicy !== void 0 && (_editPolicy$loadedPol11 = editPolicy.loadedPolicy) !== null && _editPolicy$loadedPol11 !== void 0 && _editPolicy$loadedPol11.isReadOnly || !(editPolicy !== null && editPolicy !== void 0 && (_editPolicy$loadedPol12 = editPolicy.loadedPolicy) !== null && _editPolicy$loadedPol12 !== void 0 && _editPolicy$loadedPol12.isDraft))) && !(0, _utils.isAccessBuilderPath)() && /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyButtonContainerLeft
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    size: "medium",
    variant: "secondary",
    onClick: saveDraftHandler
  }, _constants.translatedStrings.saveDraft)), isEditMode && /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyButtonContainerLeft
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    size: "medium",
    variant: "secondary",
    onClick: function onClick() {
      if (isEditMode) {
        editPolicy === null || editPolicy === void 0 ? void 0 : editPolicy.resetHandler();
      } else {
        clonePolicy === null || clonePolicy === void 0 ? void 0 : clonePolicy.resetHandler();
      }
    }
  }, _constants.translatedStrings.resetBtn)), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyButtonContainerLeft
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    size: "medium",
    variant: "secondary",
    onClick: function onClick() {
      return setCancelModal(true);
    }
  }, _constants.translatedStrings.cancelBtn))), !(0, _utils.isAccessBuilderPath)() && /*#__PURE__*/_react.default.createElement(_button.default, {
    variant: "secondary",
    size: "medium",
    onClick: function onClick() {
      return setSwitchForm(true);
    }
  }, buttonText)), validationErrors && /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicySnackbar
  }, /*#__PURE__*/_react.default.createElement(_snackbar.default, {
    title: _constants.translatedStrings.errorBarTitle,
    errorList: validationErrors,
    maxHeight: "128px"
  })), isJSON ? /*#__PURE__*/_react.default.createElement(_policyJsonEditor.default, addPolicyJSONProps) : /*#__PURE__*/_react.default.createElement(_AddPolicyForm.default, addPolicyFormProps), cancelModal && /*#__PURE__*/_react.default.createElement(_dialog.default, {
    type: "alert",
    title: _constants.translatedStrings.cancelModalTitle,
    message: _constants.translatedStrings.cancelAddPolicyMessage,
    primaryButtonText: _constants.translatedStrings.cancelModalPrimaryBtn,
    secondaryButtonText: _constants.translatedStrings.noBtn,
    onSubmit: function onSubmit() {
      cancelHandler();
    },
    onCancel: function onCancel() {
      setCancelModal(false);
    }
  }), switchForm && /*#__PURE__*/_react.default.createElement(_dialog.default, {
    type: "alert",
    title: "".concat(buttonText, "?"),
    message: _constants.translatedStrings.switchModeChangeDialogMessage(isJSON),
    primaryButtonText: _constants.translatedStrings.switchModeChangeDialogButton(isJSON),
    secondaryButtonText: _constants.translatedStrings.noBtn,
    onSubmit: function onSubmit() {
      switchHandler();
      setSwitchForm(false);
    },
    onCancel: function onCancel() {
      setSwitchForm(false);
    }
  }), showNoMembersDialog && /*#__PURE__*/_react.default.createElement(_dialog.default, {
    height: "320px",
    type: "alert",
    title: _constants.translatedStrings.membersDialogTitle,
    message: _constants.translatedStrings.membersDialogMessage,
    primaryButtonText: _constants.translatedStrings.membersDialogPrimaryBtnText,
    secondaryButtonText: _constants.translatedStrings.membersDialogSecondaryBtnText,
    onSubmit: function onSubmit() {
      setShowNoMembersDialog(false);
      postPolicyHandler();
    },
    onCancel: function onCancel() {
      setShowNoMembersDialog(false);
    }
  }));
};

AddPolicy.propTypes = {
  history: _propTypes.default.any,
  addPolicyErrors: _propTypes.default.any,
  addPolicyStatus: _propTypes.default.string,
  openNotification: _propTypes.default.func,
  createPolicy: _propTypes.default.func,
  setPageHeader: _propTypes.default.func,
  addPolicy: _propTypes.default.func,
  fetchUsers: _propTypes.default.func,
  usersData: _propTypes.default.array,
  usersDataStatus: _propTypes.default.string,
  fetchGroups: _propTypes.default.func,
  groupsData: _propTypes.default.array,
  groupsDataStatus: _propTypes.default.string,
  fetchServiceIdentities: _propTypes.default.func,
  serviceIdentitiesData: _propTypes.default.array,
  serviceIdentitiesDataStatus: _propTypes.default.string,
  fetchTokens: _propTypes.default.func,
  tokensData: _propTypes.default.array,
  tokensDataStatus: _propTypes.default.string,
  fetchPermissionsList: _propTypes.default.func,
  permissionsList: _propTypes.default.array,
  fetchConsumersList: _propTypes.default.func,
  consumersList: _propTypes.default.array,
  fetchPermissionDetails: _propTypes.default.func,
  permissionDetails: _propTypes.default.any,
  fetchPermissionActions: _propTypes.default.func,
  permissionActionsList: _propTypes.default.array,
  permissionActionsListStatus: _propTypes.default.string,
  permissionDetailsStatus: _propTypes.default.string,
  fetchRolesList: _propTypes.default.func,
  rolesListStatus: _propTypes.default.any,
  fetchRoleDetails: _propTypes.default.func,
  rolesList: _propTypes.default.array,
  roleDetails: _propTypes.default.any,
  roleDetailsStatus: _propTypes.default.string,
  editPolicy: _propTypes.default.any,
  clonePolicy: _propTypes.default.any,
  resetActionsData: _propTypes.default.func,
  initSpinnerOverlay: _propTypes.default.func,
  permissionsListStatus: _propTypes.default.string,
  getApplicationsList: _propTypes.default.func,
  applicationsListData: _propTypes.default.array,
  applicationsListStatus: _propTypes.default.string,
  consumerEntityId: _propTypes.default.string,
  redirectPath: _propTypes.default.string,
  validateChannelListStatus: _propTypes.default.string,
  validateChannelListError: _propTypes.default.string,
  validateChannelList: _propTypes.default.func,
  isConditionTypeJSON: _propTypes.default.bool
};
var _default = AddPolicy;
exports.default = _default;